/* The sitewide premium icon (circle lock icon)
 * Hides itself when user is premium.
 */
import React, { FC } from 'react';
import $image_url from 'js/utils/image_url';

const DEFAULT_SIZE = 20;

// primary - white icon in gold circle
// secondary - gold icon in white circle
// primary-transparent - transparent lock icon in gold cricle
// secondary-transparent - gold lock icon with transparent circle
export type IconColor =
  | 'primary'
  | 'secondary'
  | 'primary-transparent'
  | 'secondary-transparent';

type Props = {
  // For external styling
  className?: string;
  color?: IconColor;
  size?: number;
  marginRight?: number;
};

const PremiumIcon: FC<Props> = ({
  className,
  size = DEFAULT_SIZE,
  marginRight = 8,
  color = 'primary',
}) => {
  if (window.Aedu?.User?.current?.premium) {
    return null;
  }

  let src: string;
  switch (color) {
    case 'secondary':
      src = $image_url('premium/Lock-CircleWhite-Gold.svg');
      break;
    case 'primary-transparent':
      src = $image_url('premium/Lock-CircleGold-Transparent.svg');
      break;
    case 'secondary-transparent':
      src = $image_url('premium/Lock-NoCircle-Gold.svg');
      break;
    default:
      // primary
      src = $image_url('premium/Lock-CircleGold-White.svg');
  }

  return (
    <img
      className={className}
      src={src}
      style={{
        width: size,
        marginRight: marginRight,
      }}
    />
  );
};

export default PremiumIcon;
